<script>
export default {
  computed: {
    isLoading() {
      return this.$store.getters.getIsLoading;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/mixins/Spinner_Mixin.vue